<app-template-password
  [characters]="characters"
  [placeholder]="placeholder"
  [value]="value"
  [control]="control"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [disabled]="disabled"
  [label]="label"
  [autocomplete]="autocomplete"
/>
